import { colors, typography } from '../../../styles/theme';

const BG_BASE = '#1c1c1c';
const BG_ELEVATED = '#242424';
const BG_SURFACE = '#2e2e2e';
const BG_SEARCH_FIELD = '#141414';
const BORDER_DEFAULT = '#4a4a4a';
const BORDER_PRIMARY = '#6da8a7';
const PRIMARY_SURFACE = '#224848';
const TEXT_PRIMARY = '#d4d4d4';
const TEXT_SECONDARY = '#ababab';
const PRIMARY_ON = '#e8f4f4';

export const dialogPaperSx = {
  bgcolor: BG_BASE,
  backgroundImage: 'none',
  border: `1px solid ${BORDER_DEFAULT}`,
  borderRadius: '16px',
  overflow: 'hidden',
  height: { xs: 'calc(100vh - 120px)', sm: 620 },
  maxHeight: { xs: 'calc(100vh - 120px)', sm: 620 },
  display: 'flex',
  flexDirection: 'column',
};

export const dialogTitleSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 3,
  py: 2,
  color: '#f9fafb',
  fontFamily: typography.fontFamily.heading,
  fontSize: '15px',
  fontWeight: 600,
  letterSpacing: '0.01em',
  borderBottom: '1px solid rgba(255,255,255,0.07)',
  bgcolor: 'rgba(255,255,255,0.02)',
  flexShrink: 0,
};

export const headerIconBoxSx = {
  width: 30,
  height: 30,
  borderRadius: 1.5,
  bgcolor: 'rgba(255,255,255,0.06)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const headerListAltIconSx = { fontSize: 16, color: 'rgba(255,255,255,0.65)' };

export const headerTitleActionsBoxSx = { ml: 'auto' };

export const closeIconButtonSx = {
  color: 'rgba(255,255,255,0.35)',
  '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.06)' },
};

export const fixedTopZoneSx = {
  px: 3,
  pt: 2,
  pb: 0,
  flexShrink: 0,
  bgcolor: BG_BASE,
};

export const scrollableListZoneSx = {
  flex: 1,
  overflowY: 'auto',
  px: 3,
  pb: 1,
  '&::-webkit-scrollbar': { width: 5 },
  '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    bgcolor: 'rgba(255,255,255,0.10)',
    borderRadius: 99,
  },
  '&::-webkit-scrollbar-thumb:hover': { bgcolor: 'rgba(255,255,255,0.18)' },
};

export const fixedBottomZoneSx = {
  flexShrink: 0,
  px: 3,
  pt: 2,
  pb: 2.5,
  borderTop: '1px solid rgba(255,255,255,0.07)',
  bgcolor: BG_BASE,
};

export const subtitleTypographySx = {
  color: '#FFFFFF',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '19px',
  letterSpacing: 0,
  mb: 2,
};

export const emptyStateBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  minHeight: 320,
  py: 5,
  gap: 1.25,
};

export const emptyStateIconBoxSx = {
  width: 60,
  height: 60,
  borderRadius: '8px',
  bgcolor: BG_ELEVATED,
  p: '14px',
  gap: '10px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 0.75,
  flexShrink: 0,
};

export const emptyStateIconSx = {
  fontSize: 32,
  width: 32,
  height: 32,
  color: TEXT_PRIMARY,
};

export const emptyStateTitleSx = {
  color: TEXT_PRIMARY,
  fontFamily: typography.fontFamily.heading,
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '19px',
  letterSpacing: 0,
  textAlign: 'center',
  maxWidth: 310,
};

export const emptyStateHintSx = {
  color: TEXT_SECONDARY,
  fontFamily: typography.fontFamily.primary,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '19px',
  letterSpacing: 0,
  textAlign: 'center',
  maxWidth: 310,
};

/** CTA empty — button-primary + ícono + en círculo */
export const emptyStateCreateButtonSx = {
  textTransform: 'none',
  mt: 1.5,
  px: 2.75,
  minHeight: 44,
  height: 44,
  width: 166,
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '18.41px',
  letterSpacing: 0,
  borderRadius: '8px',
  bgcolor: colors.primary,
  color: PRIMARY_ON,
  boxShadow: 'none',
  gap: 1,
  '&:hover': {
    bgcolor: colors.primaryHover,
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    marginRight: '8px',
  },
  '&.Mui-disabled': {
    bgcolor: 'rgba(255,255,255,0.08)',
    color: 'rgba(255,255,255,0.25)',
  },
};

export const emptyStateCreateIconSx = {
  fontSize: '22px !important',
  color: 'inherit',
};

/** Nombre de lista + CTA Agregar en detalle (debajo del divider del header). */
export const detailListNameRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  width: '100%',
  minWidth: 0,
  minHeight: 44,
  mb: 0,
};

export const detailListNamePrimarySx = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  gap: '2px',
};

export const detailListNameActionsSx = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 0.75,
  width: 120,
  minWidth: 120,
};

export const detailSectionDividerSx = {
  mx: -3,
  borderColor: '#383838',
};

export const detailAddButtonSx = {
  textTransform: 'none',
  flexShrink: 0,
  height: 36,
  minHeight: 36,
  minWidth: 120,
  px: '14px',
  borderRadius: '8px',
  fontFamily: typography.fontFamily.primary,
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: 1.2,
  bgcolor: colors.primary,
  color: PRIMARY_ON,
  boxShadow: 'none',
  gap: '2px',
  '&:hover': {
    bgcolor: colors.primaryHover,
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    marginRight: '6px',
  },
};

export const detailListNameSx = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minHeight: 22,
  fontFamily: typography.fontFamily.primary,
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '22px',
  letterSpacing: 0,
  color: TEXT_PRIMARY,
  mt: 0,
  ml: 1,
};

/** Nombre en el header del detalle CAD (sin CTA Agregar: no forzar altura de 44). */
export const cadDetailNameRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  width: '100%',
  minWidth: 0,
};

export const cadDetailNameSx = {
  ...detailListNameSx,
  mt: 0,
  ml: 0,
  minHeight: 0,
  flex: '1 1 auto',
};

export const cadDetailCountsSx = {
  flexShrink: 0,
  color: TEXT_SECONDARY,
  fontFamily: typography.fontFamily.primary,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  letterSpacing: 0,
  textTransform: 'none',
  whiteSpace: 'nowrap',
};

/** Conteo a la izquierda, consultas a la derecha, pegado al nombre. */
export const detailListMetaRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  width: '100%',
  minWidth: 0,
  mt: 0,
};

/** Campo inline al renombrar lista en detalle (misma fila que el botón Agregar). */
export const detailListNameEditFieldSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.04)',
    borderRadius: '6px',
    height: 36,
    minHeight: 36,
    pl: 1,
    pr: 1,
    transition: 'background-color 0.2s ease',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.1)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.22)' },
    '&.Mui-focused': {
      backgroundColor: 'rgba(255,255,255,0.07)',
    },
    '&.Mui-focused fieldset': { borderColor: 'rgba(255,255,255,0.35)', borderWidth: '1px' },
  },
  '& .MuiOutlinedInput-input': {
    color: '#ffffff',
    py: 0,
    px: 0,
    height: 36,
    letterSpacing: 0,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16px',
    '&::placeholder': { color: 'rgba(255,255,255,0.3)', opacity: 1 },
  },
};

/** Padding simétrico con la toolbar (chips/+) para que el anillo de preview no se recorte ni se salga. */
export const listSx = { pl: '2px', pr: '6px', pt: '2px', pb: '2px' };

/** Contenedor de sección colapsable (Mis listas / Compartidas). */
export const listsSectionRootSx = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  mb: 1.5,
  bgcolor: 'transparent',
  overflow: 'hidden',
  minHeight: 0,
};

/** Cuando la sección está expandida, crece para ocupar el alto disponible del panel. */
export const getListsSectionRootSx = (expanded, { fillHeight = false } = {}) => ({
  ...listsSectionRootSx,
  flex: expanded && fillHeight ? '1 1 0' : '0 0 auto',
  mb: 1.5,
  '&:last-child': { mb: 0 },
});

export const listsSectionHeaderSx = (expanded = true) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  width: '100%',
  minHeight: 60,
  py: '18px',
  px: '10px',
  m: 0,
  border: 'none',
  borderBottom: expanded ? 'none' : '1px solid rgba(255,255,255,0.06)',
  borderRadius: expanded ? '8px 8px 0 0' : '8px',
  bgcolor: '#141414',
  cursor: 'pointer',
  color: 'inherit',
  font: 'inherit',
  textAlign: 'left',
  transition: 'border-radius 0.15s ease',
  '&:hover': {
    bgcolor: '#141414',
  },
  '&:focus-visible': {
    outline: `2px solid ${colors.primary}`,
    outlineOffset: -2,
  },
});

export const listsSectionTitleSx = {
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '14px',
  lineHeight: '19px',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: '#D4D4D4',
};

export const listsSectionChevronSx = (expanded) => ({
  color: '#ABABAB',
  fontSize: 20,
  transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'transform 0.2s ease',
  flexShrink: 0,
});

export const listsSectionBodySx = {
  width: '100%',
  p: '8px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#141414',
  // border: '1px solid #383838',
  borderTop: '1px solid #383838',
  borderRadius: '0 0 8px 8px',
};

/** Área desplazable solo para cards/registros (toolbar queda fija arriba). */
export const listsSectionScrollContentSx = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(255,255,255,0.22) transparent',
  '&::-webkit-scrollbar': {
    width: 6,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255,255,255,0.10)',
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(255,255,255,0.18)',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
};

export const listsSectionToolbarWrapSx = {
  flexShrink: 0,
  width: '100%',
};

/** Body de sección que debe llenar el alto restante (scroll interno). */
export const listsSectionBodyFillSx = {
  flex: 1,
  minHeight: 0,
  maxHeight: 'none',
  display: 'flex',
  flexDirection: 'column',
};

export const listsIndexSectionsStackSx = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  pt: 2,
};

export const listsSectionEmptySx = {
  py: 1.5,
  px: 1,
  fontFamily: typography.fontFamily.primary,
  fontSize: '13px',
  lineHeight: '18px',
  color: 'rgba(171,171,171,0.9)',
  textAlign: 'center',
  maxWidth: 320,
};

/** Centra el mensaje vacío en el alto restante del body de la sección. */
export const listsSectionEmptyWrapSx = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 0,
  width: '100%',
  px: 1,
};

export const listFiltersBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  width: '100%',
  mb: 0,
};

/** Fila search + botón agregar — gap 10. */
export const listSearchToolbarSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '100%',
};

/** Input buscar — 48 alto, bg/page, border default en reposo, primary con foco/texto. */
export const listSearchFieldSx = {
  flex: 1,
  minWidth: 0,
  mt: -1.5,
  '& .MuiOutlinedInput-root': {
    height: 44,
    minHeight: 44,
    backgroundColor: BG_SEARCH_FIELD,
    borderRadius: '8px',
    boxSizing: 'border-box',
    pl: '14px',
    pr: '16px',
    '& fieldset': {
      borderColor: 'var(--border-default, #4A4A4A)',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: 'var(--border-default, #4A4A4A)',
      borderWidth: '1px',
    },
    '&:has(input:not(:placeholder-shown)) fieldset': {
      borderColor: BORDER_PRIMARY,
      borderWidth: '1px',
    },
    '&.Mui-focused fieldset': {
      borderColor: BORDER_PRIMARY,
      borderWidth: '2px',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#FFFFFF',
    fontFamily: typography.fontFamily.primary,
    fontSize: '14px',
    lineHeight: '20px',
    py: '11px',
    px: 0,
    pl: '10px',
    '&::placeholder': { color: TEXT_SECONDARY, opacity: 1 },
  },
  '& .MuiInputAdornment-root': {
    color: TEXT_SECONDARY,
    marginRight: 0,
    marginLeft: 0,
  },
};

export const listSearchIconSx = {
  fontSize: 20,
  color: TEXT_SECONDARY,
  display: 'block',
};

/** Botón + en toolbar de Mis listas — misma altura que chips de filtro (28px). */
export const listAddButtonSx = {
  width: 28,
  height: 28,
  minWidth: 28,
  flexShrink: 0,
  p: 0,
  borderRadius: '4px',
  border: `1px solid ${BORDER_DEFAULT}`,
  bgcolor: BG_SEARCH_FIELD,
  color: PRIMARY_ON,
  boxSizing: 'border-box',
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.06)',
    borderColor: PRIMARY_ON,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 16,
    color: PRIMARY_ON,
  },
};

export const listFilterChipsRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
  ml: 1,
  mb: 1,
};

/** Toolbar dentro del body de Mis listas — alinea chips/+ con el padding horizontal de las cards (12px). */
export const listsSectionToolbarRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  pl: '2px',
  pr: '6px',
};

/** Chips Todos / Público / Privado — alto 28. */
export const getListFilterChipSx = (active) => ({
  textTransform: 'none',
  height: 28,
  minHeight: 28,
  px: '8px',
  py: 0,
  borderRadius: '4px',
  fontFamily: typography.fontFamily.primary,
  fontSize: '12px',
  fontWeight: 500,
  letterSpacing: 0,
  lineHeight: 1,
  textAlign: 'center',
  verticalAlign: 'middle',
  gap: '4px',
  border: '1px solid',
  borderColor: BORDER_PRIMARY,
  bgcolor: active ? PRIMARY_SURFACE : 'transparent',
  color: active ? '#FFFFFF' : BORDER_PRIMARY,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: active ? PRIMARY_SURFACE : 'rgba(109,168,167,0.10)',
    borderColor: BORDER_PRIMARY,
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    marginRight: '4px',
    color: 'inherit',
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: 16,
  },
});

/** Variante icon-only para filtros Público / Privado. */
export const getListFilterIconChipSx = (active) => ({
  ...getListFilterChipSx(active),
  minWidth: 28,
  width: 28,
  px: 0,
  justifyContent: 'center',
  '& .MuiButton-startIcon': {
    margin: 0,
  },
});

export const listVisibilitySelectSx = {
  minWidth: 150,
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.03)',
    borderRadius: 1.5,
    '& fieldset': { borderColor: 'rgba(255,255,255,0.10)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.22)' },
    '&.Mui-focused fieldset': { borderColor: 'rgba(255,255,255,0.35)' },
  },
  '& .MuiSelect-select': { color: '#ffffff', fontSize: '13px' },
  '& .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.60)' },
};

export const getListItemRootSx = (isLast) => ({
  display: 'block',
  mb: isLast ? 0 : '8px',
});

/** Card de lista — Figma: bg/elevated, radius 8, padding 10×12, gap 10. */
export const getListRowSurfaceSx = (isEditing) => ({
  border: 'none',
  borderRadius: '8px',
  px: '12px',
  py: '10px',
  bgcolor: isEditing ? '#2e2e2e' : '#242424',
  boxSizing: 'border-box',
  transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
  ...(isEditing
    ? {}
    : {
        '&:hover': {
          bgcolor: '#2a2a2a',
        },
      }),
});

/** Anillo de “ubicar en el mapa”: inset para no recortarse ni desbordar (sobre todo la 1ª card). */
export const listRowPreviewActiveSx = {
  boxShadow: `inset 0 0 0 1px ${colors.primary}`,
};

/**
 * Card de registro «ubicada» (⋮ → Ubicar en el mapa): anillo inset en un
 * `::after` para que no lo tape el contenido ni lo recorte el scroll.
 * Mismo estilo en Registros y en el detalle de lista.
 */
export const getRecordCardLocateActiveSx = (accent = colors.primary) => ({
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    pointerEvents: 'none',
    zIndex: 2,
    boxShadow: `inset 0 0 0 1px ${accent}`,
  },
});

export const editRowBoxSx = { display: 'flex', gap: 1, alignItems: 'center' };

export const textFieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.04)',
    borderRadius: 1.5,
    transition: 'background-color 0.2s ease',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.1)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.22)' },
    '&.Mui-focused': {
      backgroundColor: 'rgba(255,255,255,0.07)',
    },
    '&.Mui-focused fieldset': { borderColor: 'rgba(255,255,255,0.35)', borderWidth: '1px' },
  },
  '& .MuiOutlinedInput-input': {
    color: '#ffffff',
    fontSize: '13px',
    '&::placeholder': { color: 'rgba(255,255,255,0.3)', opacity: 1 },
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.5)' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'rgba(255,255,255,0.7)' },
};

export const saveEditIconButtonSx = {
  width: 24,
  height: 24,
  minWidth: 24,
  p: '4px',
  color: colors.primary,
  bgcolor: 'rgba(72,146,145,0.14)',
  borderRadius: 1.25,
  '&:hover': { bgcolor: 'rgba(72,146,145,0.22)' },
  '&.Mui-disabled': { color: 'rgba(72,146,145,0.35)' },
};

export const saveEditProgressSx = { color: colors.primary };

export const cancelEditIconButtonSx = {
  width: 24,
  height: 24,
  minWidth: 24,
  p: '4px',
  color: 'rgba(255,255,255,0.4)',
  borderRadius: 1.25,
  '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.07)' },
};

export const viewRowBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  width: '100%',
};

export const viewRowMainSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  flex: 1,
  minWidth: 0,
  width: '100%',
};

export const viewRowTitleRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  width: '100%',
  minWidth: 0,
};

export const listNameTypographySx = {
  fontFamily: typography.fontFamily.primary,
  color: '#D4D4D4',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '18px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  flex: 1,
};

export const listCardMetaRowSx = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  gap: '12px',
  minWidth: 0,
};

export const defaultListChipSx = {
  height: 18,
  fontSize: '10px',
  fontWeight: 500,
  bgcolor: 'rgba(234,179,8,0.1)',
  color: '#fbbf24',
  border: '1px solid rgba(234,179,8,0.2)',
  '& .MuiChip-icon': { color: '#fbbf24', ml: '4px' },
  '& .MuiChip-label': { px: '6px' },
};

export const defaultListChipIconSx = { fontSize: '12px !important' };

export const getPublicChipSx = (isPublic) => ({
  height: 18,
  fontSize: '10px',
  fontWeight: 500,
  bgcolor: isPublic ? 'rgba(34,197,94,0.12)' : 'rgba(255,255,255,0.06)',
  color: isPublic ? '#4ade80' : 'rgba(156,163,175,0.85)',
  border: '1px solid',
  borderColor: isPublic ? 'rgba(34,197,94,0.25)' : 'rgba(255,255,255,0.10)',
  '& .MuiChip-label': { px: '6px' },
});

export const sharedLinkChipSx = {
  height: 18,
  fontSize: '10px',
  fontWeight: 500,
  bgcolor: 'rgba(72,146,145,0.10)',
  color: colors.primary,
  border: '1px solid',
  borderColor: 'rgba(72,146,145,0.28)',
  '& .MuiChip-label': { px: '6px' },
  '& .MuiChip-icon': { color: colors.primary, fontSize: '12px !important' },
};

/** Ancho fijo para que Público/Privado arranquen en la misma columna en todas las cards. */
export const getListItemCountTypographySx = () => ({
  fontFamily: typography.fontFamily.primary,
  color: '#ABABAB',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '22px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  minWidth: '138px',
});

/** Badge Público / Privado en card de lista — mismo color primario para ambos. */
export const getListVisibilityBadgeSx = (_variant) => {
  const accent = '#6DA8A7';
  return {
    height: 22,
    borderRadius: '4px',
    fontFamily: typography.fontFamily.primary,
    fontSize: '11px',
    fontWeight: 500,
    bgcolor: 'transparent',
    color: accent,
    border: `1px solid ${accent}`,
    flexShrink: 0,
    '& .MuiChip-icon': {
      color: 'inherit',
      fontSize: '14px !important',
      ml: '6px',
      mr: '-2px',
    },
    '& .MuiChip-label': { px: 0.75 },
  };
};

export const listCardActionIconSx = {
  color: '#FFFFFF',
  p: 0.5,
  '&:hover': {
    color: colors.primary,
    bgcolor: 'rgba(255,255,255,0.06)',
  },
  '&.Mui-disabled': {
    color: 'rgba(171,171,171,0.35)',
  },
};

export const rowActionsBoxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.25,
  flexShrink: 0,
};

export const deleteRowProgressSx = { color: '#f87171' };

export const createSectionCaptionSx = {
  color: 'rgba(255,255,255,0.35)',
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  display: 'block',
  mb: 1.25,
};

export const createRowBoxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'nowrap',
};

export const createVisibilityBoxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  px: 1,
  py: 0.25,
  borderRadius: 1.5,
  border: '1px solid rgba(255,255,255,0.08)',
  bgcolor: 'rgba(255,255,255,0.03)',
  flexShrink: 0,
};

export const createVisibilityLabelSx = (isPublic) => ({
  fontSize: '11.5px',
  color: isPublic ? '#4ade80' : 'rgba(156,163,175,0.9)',
  userSelect: 'none',
  whiteSpace: 'nowrap',
});

export const createListButtonSx = {
  textTransform: 'none',
  flexShrink: 0,
  px: 2,
  height: 30,
  fontSize: '13px',
  fontWeight: 600,
  borderRadius: '8px',
  bgcolor: colors.primary,
  color: PRIMARY_ON,
  boxShadow: 'none',
  '&:hover': {
    bgcolor: colors.primaryHover,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: 'rgba(255,255,255,0.08)',
    color: 'rgba(255,255,255,0.25)',
  },
};

export const createButtonLoadingIconSx = { color: 'rgba(0,0,0,0.6)' };

/** Vista / form “NUEVA LISTA” */
export const createListFormBoxSx = {
  pt: 2,
  pb: 2.5,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  flexShrink: 0,
};

export const createListLabelSx = {
  color: '#FFFFFF',
  fontFamily: typography.fontFamily.heading,
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '20px',
  letterSpacing: 0,
  mb: 1,
  display: 'block',
};

/** Field / Flexible — fill × 40, radius 8, padding 8/9, bg/surface (sin borde) */
export const createListNameFieldSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: BG_SURFACE,
    borderRadius: '8px',
    minHeight: 40,
    height: 40,
    boxSizing: 'border-box',
    gap: '8px',
    transition: 'background-color 0.2s ease',
    '& fieldset': { border: 'none' },
    '&:hover fieldset': { border: 'none' },
    '&.Mui-focused': {
      backgroundColor: BG_SURFACE,
    },
    '&.Mui-focused fieldset': { border: 'none' },
  },
  '& .MuiOutlinedInput-input': {
    color: '#FFFFFF',
    fontFamily: typography.fontFamily.primary,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: 0,
    py: '8px',
    px: '9px',
    height: 'auto',
    boxSizing: 'border-box',
    '&::placeholder': { color: TEXT_SECONDARY, opacity: 1 },
  },
};

export const createListActionsRowSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '10px',
  flexWrap: 'wrap',
};

/** button-secondary / Cancelar — 44 alto, padding 14×24, radius 8 */
export const createListCancelButtonSx = {
  textTransform: 'none',
  height: 44,
  minHeight: 44,
  minWidth: 97,
  px: '24px',
  py: '14px',
  borderRadius: '8px',
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: 1.2,
  letterSpacing: 0,
  color: '#FFFFFF',
  borderColor: 'rgba(255,255,255,0.85)',
  borderWidth: '1px',
  bgcolor: 'transparent',
  boxShadow: 'none',
  boxSizing: 'border-box',
  '&:hover': {
    borderColor: '#FFFFFF',
    borderWidth: '1px',
    bgcolor: 'rgba(255,255,255,0.06)',
  },
  '&.Mui-disabled': {
    height: 44,
    minHeight: 44,
    color: 'rgba(255,255,255,0.45)',
    borderColor: 'rgba(255,255,255,0.28)',
  },
};

/** button-primary / Crear lista — 44 alto, padding 14×24, radius 8, sin íconos */
export const createListSubmitButtonSx = {
  textTransform: 'none',
  height: 44,
  minHeight: 44,
  minWidth: 107,
  px: '24px',
  py: '14px',
  borderRadius: '8px',
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: 1.2,
  letterSpacing: 0,
  bgcolor: colors.primary,
  color: PRIMARY_ON,
  boxShadow: 'none',
  boxSizing: 'border-box',
  '&:hover': {
    bgcolor: colors.primaryHover,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    height: 44,
    minHeight: 44,
    minWidth: 107,
    bgcolor: '#3a3a3a',
    color: 'rgba(255,255,255,0.35)',
  },
};

export const addFlowFooterRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  px: 3,
  py: 2,
  flexShrink: 0,
  bgcolor: BG_BASE,
};

export const addFlowFooterLabelSx = {
  color: TEXT_SECONDARY,
  fontFamily: typography.fontFamily.primary,
  fontSize: '13px',
  fontWeight: 500,
  flex: 1,
  minWidth: 0,
};

export const addFlowCancelButtonSx = {
  textTransform: 'none',
  height: 40,
  minHeight: 40,
  px: 1.5,
  borderRadius: '8px',
  borderColor: 'rgba(255,255,255,0.18)',
  color: TEXT_PRIMARY,
  fontSize: '14px',
  fontWeight: 500,
  '&:hover': { borderColor: 'rgba(255,255,255,0.28)', bgcolor: 'rgba(255,255,255,0.04)' },
};

export const addFlowReviewButtonSx = {
  textTransform: 'none',
  height: 40,
  minHeight: 40,
  px: 2,
  borderRadius: '8px',
  bgcolor: colors.primary,
  color: PRIMARY_ON,
  fontSize: '14px',
  fontWeight: 500,
  boxShadow: 'none',
  '&:hover': { bgcolor: colors.primaryHover, boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: '#3a3a3a', color: 'rgba(255,255,255,0.35)' },
};

export const addFlowConfirmButtonSx = {
  ...addFlowReviewButtonSx,
  minWidth: 100,
};

export const addFlowTabsRowSx = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 2,
  width: 'auto',
  mx: -3,
  px: 3,
  pb: 0.5,
  boxSizing: 'border-box',
};

export const getAddFlowTabButtonSx = (active) => ({
  textTransform: 'none',
  height: 44,
  minHeight: 44,
  width: '100%',
  px: 2,
  py: 0,
  borderRadius: '8px',
  border: '1px solid',
  borderColor: active ? BORDER_PRIMARY : BORDER_DEFAULT,
  bgcolor: 'transparent',
  color: active ? TEXT_PRIMARY : TEXT_SECONDARY,
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '19px',
  boxShadow: 'none',
  gap: '10px',
  '&:hover': {
    borderColor: active ? BORDER_PRIMARY : 'rgba(255,255,255,0.45)',
    bgcolor: 'rgba(255,255,255,0.03)',
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    marginRight: '8px',
    color: 'inherit',
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: 22,
  },
});

export const addFlowMapHintBoxSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 360,
  py: 6,
  px: 2,
  bgcolor: 'transparent',
  border: 'none',
  textAlign: 'center',
};

export const addFlowMapHintIconSx = {
  fontSize: 48,
  color: TEXT_PRIMARY,
  mb: 2,
};

export const addFlowMapHintTitleSx = {
  color: TEXT_PRIMARY,
  fontFamily: typography.fontFamily.primary,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '19px',
  maxWidth: 290,
};

export const addFlowMapHintTextSx = {
  color: TEXT_SECONDARY,
  fontFamily: typography.fontFamily.primary,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '19px',
  mt: 1,
  maxWidth: 270,
};

export const addFlowRecordCardSx = {
  borderRadius: '8px',
  bgcolor: BG_ELEVATED,
  px: '12px',
  py: '10px',
  overflow: 'hidden',
};

/**
 * Card placeholder mientras se resuelve el lote clickeado en el mapa.
 * Mismo padding y gap que el header de `RecordLotRow` para que las dos líneas
 * de texto le den exactamente la altura de una card colapsada.
 */
export const addFlowMapPickLoadingCardSx = {
  ...addFlowRecordCardSx,
  display: 'flex',
  alignItems: 'flex-start',
  gap: '6px',
};

export const addFlowRecordTitleSx = {
  color: TEXT_PRIMARY,
  fontSize: '14px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const addFlowRecordMetaSx = {
  color: TEXT_SECONDARY,
  fontSize: '12px',
  mt: 0.25,
};

export const addFlowReviewSectionTitleSx = {
  color: TEXT_PRIMARY,
  fontSize: '13px',
  fontWeight: 600,
  letterSpacing: '0.02em',
};


/** Label de totales de Registros y del detalle de lista («N lotes · N unidades · …»). Mismo gris de las cards. */
export const recordCountsLabelSx = {
  color: '#ababab',
  fontFamily: typography.fontFamily.primary,
  fontSize: '12px',
  lineHeight: '16px',
};

/** Fila de totales (izquierda) + orden (derecha), igual en Registros y detalle de lista. */
export const recordCountsRowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  width: '100%',
  minWidth: 0,
  flexWrap: 'nowrap',
};

/**
 * Totales + «Ordenar por:» + vista. Si no entran en una línea, el orden y la
 * vista bajan a la siguiente (alineados a la derecha): ningún texto se corta.
 */
export const recordCountsWrapRowSx = {
  ...recordCountsRowSx,
  flexWrap: 'wrap',
  rowGap: 0.5,
};

/** Grupo derecho de la fila de totales: «Ordenar por:» + selector de vista. */
export const recordToolbarControlsSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  ml: 'auto',
  flexShrink: 0,
};
